import { Controller } from 'react-hook-form';
import { Form, Input } from 'antd';
import type { FieldValues } from 'react-hook-form';
import type { InputProps } from 'antd';
import type { RHFBaseProps, CommonChrome } from './types';
import { DEFAULT_FORM_LAYOUT } from './constants';

export type ControlledInputProps<TFieldValues extends FieldValues = FieldValues> =
  RHFBaseProps<TFieldValues> &
    CommonChrome &
    Omit<InputProps, 'value' | 'onChange' | 'onBlur'>;

export function ControlledInput<TFieldValues extends FieldValues = FieldValues>({
  control,
  name,
  label,
  required,
  disabled,
  help,
  layout,
  fieldClassName,
  ...rest
}: ControlledInputProps<TFieldValues>) {
  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { value, onChange, onBlur }, fieldState }) => (
        <Form.Item
          label={label}
          required={required}
          validateStatus={fieldState.error ? 'error' : undefined}
          help={fieldState.error?.message ?? help}
          layout={layout ?? DEFAULT_FORM_LAYOUT}
          className={fieldClassName}
        >
          <Input
            {...rest}
            value={value ?? ''}
            onChange={e => onChange(e.target.value)}
            onBlur={onBlur}
            disabled={disabled}
          />
        </Form.Item>
      )}
    />
  );
}
